import { useTranslation } from "react-i18next";
import Button from "./Button";

type ErrorProps = React.PropsWithChildren<{
  onAgain?: () => void;
  buttonTitle?: string;
}>;

const Error = ({ children, onAgain, buttonTitle }: ErrorProps) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      <h2 className="text-4xl font-extrabold mb-2">{t("somethingWrong")}</h2>
      <p className="mb-6 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48 dark:text-gray-400">
        {t("errorDescription")}: {children}
      </p>
      {onAgain && (
        <Button onClick={onAgain}>{buttonTitle ?? t("tryAgain")}</Button>
      )}
    </div>
  );
};

export default Error;
